<script setup>

import { store } from "@/store/store";
import {useRouter} from "vue-router";
import {computed} from "vue";

const router = useRouter();

</script>

<template>
  <div class="navbar bg-base-100">
    <div class="flex-1">
      <a class="btn btn-ghost text-xl text-neutral-content" @click="router.push('/')">AliasKids</a>
    </div>
    <div>
      <button
          class="btn btn-ghost text-xl text-neutral-content"
          @click="store.commit('toggleLang')">
        {{ store.state.lang }}
      </button>
    </div>
    <div class="flex-none text-neutral-content">
      {{`${store.state.index + 1} / ${store.state.rows.length}`}}
    </div>
  </div>
  <div class="hidden">
    <img
        :src="store.getters.currentImgSrc"
         @load="console.log('loaded', store.state.index)"
        alt="preloader">
    <img
        v-if="store.state.index < store.state.rows.length"
        :src="store.getters.nextImgSrc"
        @load="console.log('loaded next after', store.state.index)"
        alt="preloader">
  </div>
</template>